export const ActivityGameRoutes = [{
  path: '/ActivityGame',
  component: () => import('./ActivityGame.vue'),
  meta: {
    crumbName: '活动展演',
  },
  children: [
    {
      path: '',
      name: '正在进行',
      component: () => import('../activityGaming.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false,
      }
    }, {
      path: 'activityDetail',
      name: '活动比赛详情',
      component: () => import('../activityDetail.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false,
      }
    }, {
      path: 'history',
      name: '历史回顾',
      component: () => import('../history.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false,
      }
    }, {
      path: 'detail',
      name: '活动详情',
      component: () => import('../detail.vue'),
      meta: {
        //标明是否需要登录后才能访问
        auth:false
      }
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/pages/ActivityGame/router/ActivityGame.routes.js